import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

export function AddButton({
  onClick,
  label
}: {
  onClick: () => void;
  label?: string;
}): JSX.Element {
  return (
    <Tooltip title={label ?? 'Add'}>
      <IconButton
        onClick={onClick}
        aria-label={label ?? 'Add'}
        sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          '&:hover': {
            backgroundColor: 'primary.main',
            color: 'white'
          }
        }}
      >
        <AddIcon />
      </IconButton>
    </Tooltip>
  );
}
